import { forwardRef } from "react";

export default function ArrowThird({ id, value, backgroundColor }) {
    return (
        <div className="arrow-individual-container" id={id}>
            <div
                className="arrow-individual arrow-no-three"
                style={{
                    width: '415px',
                    background: 'rgba(24, 62, 92, 1)',
                    // clipPath: 'polygon(10% 806.25px, 7% 104.812px, 18% 57.375px, 29% 104.812px, 67% 806.25px)',
                }}>
            </div>
            <span
                className="arrow-no-text"
                style={{
                    position: 'absolute',
                    fontSize: '120px',
                    fontWeight: 'bold',
                    color: '#fff',
                    fontFamily: "GothamCond-Bold",
                    left: '820px'
                }}>{Math.round(value)}% <div class="arrow-shadow arrow-shadow-right"></div></span>
        </div>
    );
}
